import React from 'react';
import homePageStyles from '../home.module.css';
import sectionStyles from './index.module.css';
import Grid from '@material-ui/core/Grid';
import { HeroBackdrop, HeroIllustration } from '../HomeDecor';

class MainSection extends React.Component {
  render() {
    return (
      <section className={`${homePageStyles.mainSection} section`}>
        <HeroBackdrop />
        <Grid
          container
          spacing={0}
          alignItems="center"
          justify="center"
          className={`${sectionStyles.heroGrid} ${sectionStyles.contentContainer} contentContainer`}
        >
          <Grid item xs={12} lg={6}>
            <div className={`${sectionStyles.businessInformation}`}>
              <div className={`${sectionStyles.businessName}`}><span>Mimosa</span> Solutions</div>
              <div className={`${sectionStyles.slogan}`}>
                Innovation to run your business
              </div>
              <p className={sectionStyles.heroSubline}>
                Membership, billing, and front-desk tools for gyms and studios—built with owners, refined since 2017.
              </p>
            </div>
          </Grid>
          <Grid item xs={12} lg={6}>
            <div className={sectionStyles.heroVisual}>
              <HeroIllustration />
            </div>
          </Grid>
        </Grid>
      </section>
    );
  }
}

export default MainSection;